import React, { useEffect, useState } from "react";
import styles from "./ImageTextSection.module.scss";
import { useNavigate } from "react-router-dom";

interface ContentProps {
  imageSrc: string;
  imageAlt: string;
  content: string[] | string;
  reverse?: boolean;
  colImageValue?: number;
  colTextValue?: number;
  subContent?: (string | JSX.Element)[];
  heading?: string;
  showMoreButton?: boolean;
  buttonText?: string;
  isMobileReverse?: boolean;
  imageAlign?: string;
  navigateTo?: string;
  imageHeight?: number | string;
  imageHeightMobile?:number | string;
  imageHeightTablet?:number | string;
  imageAlignInMob?:number | string;
  contentPosition?:boolean;
  gutter?:boolean
}

const ImageTextContent: React.FC<ContentProps> = ({
  imageSrc,
  imageAlt,
  content,
  reverse = false,
  colImageValue = 6,
  colTextValue = 6,
  subContent = [],
  heading,
  showMoreButton = false,
  buttonText,
  isMobileReverse = false,
  imageAlign = "center",
  navigateTo = "",
  imageHeight = "",
  imageHeightMobile="",
  imageHeightTablet="",
  imageAlignInMob="center",
  contentPosition=false,
  gutter=false
}) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth <= 1024);



  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsTablet(window.innerWidth <= 1024)
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className={`row ${gutter ? 'g-3' : ''} ${
        reverse ? styles.reverseRow : isMobileReverse ? styles.isMobileReverse : ""
      }`}
    >
      <div
        className={`col-lg-${colImageValue} col-md-12 col-sm-12 d-flex justify-content-${isTablet ? imageAlignInMob : imageAlign} align-items-start`}
      >
        <img
          src={imageSrc}
          alt={imageAlt}
          className="img-fluid"
          style={{
            height: isMobile 
              ? (typeof imageHeightMobile === "number" ? `${imageHeightMobile}px` : imageHeightMobile) 
              : isTablet ? (typeof imageHeightTablet === "number" ? `${imageHeightTablet}px` : imageHeightTablet) : (typeof imageHeight === "number" ? `${imageHeight}px` : imageHeight),
            width: "auto",
          }}
          
        />
      </div>

      <div className={`col-lg-${colTextValue} col-md-12 col-sm-12 ${contentPosition ? `${styles.contentDiv} d-flex flex-column justify-content-center align-items-start` : styles.contentDiv } `}>
        {heading && <p className="heading mb-4">{heading}</p>}

        {Array.isArray(content)
          ? content.map((paragraph, index) => (
              <p
                key={index}
                className={`para ${styles.contentLineHeight}`}
                dangerouslySetInnerHTML={{ __html: paragraph }}
              ></p>
            ))
          : content}

        {subContent && subContent.length > 0 && (
          <div>
            {subContent.map((item, index) => (
              <p key={index} className="para">
                {item}
              </p>
            ))}
          </div>
        )}

        {showMoreButton && (
          <button className={`secondary-btn`} onClick={() => navigate(navigateTo)}>
            {buttonText}
          </button>
        )}
      </div>
    </div>
  );
};

export default ImageTextContent;
